module.exports = __webpack_public_path__ + "static/media/test.e074ff18.png";